import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';
import { environment } from '@env/environment';
import { CurrentUserQuery } from '@state/auth-state/current-user.query';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  getBrandRedirectUrl,
  getConsultantRedirectUrl,
  getFactoryRedirectUrl
} from '../utils/default-route.util';
@Injectable({ providedIn: 'root' })
export class AlreadyLoginGuard implements CanActivate {
  private readonly currentUserQuery = inject(CurrentUserQuery);
  canActivate(): Observable<boolean> {
    return this.currentUserQuery.select().pipe(
      map(({ data }) => {
        if (!data || !Object.keys(data).length || !data.userType) {
          return true;
        }
        window.location.href = this.getBaseRoute(data);
        return false;
      })
    );
  }
  private getBaseRoute(data: any): string {
    const accessType = data?.userType?.toLowerCase?.();
    switch (accessType) {
      case 'rtis_admin':
      case 'admin':
        return `${environment.ADMIN_WEB_ENDPOINT}admin`;
      case 'group_of_factory':
        return `${environment.ADMIN_WEB_ENDPOINT}group`;
      case 'factory':
        return getFactoryRedirectUrl(environment.SUPPLIER_WEB_ENDPOINT, data);
      case 'brand':
        return getBrandRedirectUrl(environment.BUYER_WEB_ENDPOINT);
      case 'consultant':
        return getConsultantRedirectUrl(environment.CONSULTANT_WEB_ENDPOINT, data);
      default:
        return `${environment.AUTH_WEB_ENDPOINT}sign-in`;
    }
  }
}
